import React from "react";
import { Button } from "antd";
import { SiTiktok } from "react-icons/si";
import styled from "styled-components";
import { CUSTOM_COLORS } from "@/shared/theme/colorUtils";

const SocialConnectContainer = styled.div`
	text-align: center;
	padding: 1rem 0;
`;

const ConnectTikTokButton = styled(Button)`
	height: 40px;
	border-radius: 20px;
	font-size: 0.9rem;
	font-weight: 500;
	border: 1px solid #d9d9d9;
	background: white;
	color: #333;
	width: 200px;
	margin-bottom: 1rem;

	&:hover {
		border-color: ${CUSTOM_COLORS.PRIMARY};
		color: ${CUSTOM_COLORS.PRIMARY};
	}
`;

const SecuritySection = styled.div`
	text-align: left;
	margin-top: 2rem;
`;

const SecurityTitle = styled.h3`
	font-size: 1.25rem;
	font-weight: bold;
	color: #333;
	margin: 0 0 1rem 0;
`;

const SecurityList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0 0 2rem 0;
`;

const SecurityItem = styled.li`
	font-size: 0.875rem;
	color: #666;
	margin-bottom: 0.5rem;
	padding-left: 1rem;
	position: relative;

	&::before {
		content: "•";
		color: ${CUSTOM_COLORS.PRIMARY};
		position: absolute;
		left: 0;
	}
`;

type SocialConnectStepProps = {
	onConnect?: () => void;
};

const SocialConnectStep: React.FC<SocialConnectStepProps> = ({ onConnect }) => {
	return (
		<SocialConnectContainer>
			<ConnectTikTokButton icon={<SiTiktok style={{ color: "#000000" }} />} onClick={onConnect}>
				Connect TikTok
			</ConnectTikTokButton>
			<SecuritySection>
				<SecurityTitle>Connect Safely, Share Freely</SecurityTitle>
				<SecurityList>
					<SecurityItem>We never access or store your login or password information.</SecurityItem>
					<SecurityItem>
						At no point will anyone be able to post, modify or delete your account data
					</SecurityItem>
					<SecurityItem>
						You have full control over what information you share, and you can manage it at any time.
					</SecurityItem>
				</SecurityList>
			</SecuritySection>
		</SocialConnectContainer>
	);
};

export default SocialConnectStep;
